module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_2-b25728e210ddb6df2ee39ecff403f733.jpg";